import { EnvironmentService } from 'shared/services';

type QrCheckoutConfig = {
  isOpusCompany: boolean;
};

export const getQrCheckoutDeeplinkUrl = (
  workItemId: string,
  { isOpusCompany }: QrCheckoutConfig
) => {
  const opusDeeplinkUrl = EnvironmentService.getVariable('QR_CHECKOUT_OPUS_DEEPLINK_URL');
  if (isOpusCompany && opusDeeplinkUrl) {
    return `${opusDeeplinkUrl}?workId=${workItemId}`;
  }
  return `${EnvironmentService.getVariable('QR_CHECKOUT_DEEPLINK_URL')}?workId=${workItemId}`;
};
